<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute"
    ref="freight-label-detail"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :warningSummary="warningSummary"
    :tabs="{}"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionTemplate from "@/templates/transaction.vue";
import { mapGetters } from "vuex";
import ApiService from "@/_services/api/api.service.js";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      warningSummary: [],
      backRoute: "/almondco-freight-labels",
      dataModel: {
        RecordId: undefined,
        SeasonYear: undefined,
        DepotDocket: undefined,
        RunNo: undefined,
        BinCardNo: undefined,
        BagsPerPallet: undefined,
        ProductDescription: undefined,
        ProductCode: undefined,
        BranchCode: undefined,
        LotNo: undefined,
        LotSequenceNo: undefined,
        Include: undefined,
      },
      selectedRows: {},
      originalBins: {},
      checkBoxValuesHaveChanged: false,
    };
  },
  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    getBackButtonRoute() {
      return this.backRoute;
    },
    getDataModel() {
      return this.dataModel;
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Freight Label Review",
          pdf: false,
          audit: false,
          status: false,
          notes: false,
          save: true,
          saveOptions: {
            items: [
              { text: "Save", value: "S", default: true },
              { text: "Cancel", value: "C" },
            ],
            keyExpr: "value",
            displayExpr: "text",
            dropDownOptions: {
              width: "100px",
            },
            saveKey: "saveOption",
          },
          saveCallback: this.saveCallback,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          title: {
            primary: {
              primary: {
                dataField: undefined,
                text: "Review",
              },
            },
            secondary: {
              dataField: undefined,
              text: "Freight Label",
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "LotNo",
                      dataField: "LotNo",
                    },
                    {
                      screenField: "SequenceNo",
                      dataField: "LotSequenceNo",
                    },
                    {
                      screenField: "Variety",
                      dataField: "ProductDescription",
                    },
                    {
                      screenField: "Bins",
                      label: "Bags / Pallet",
                      dataField: "BagsPerPallet",
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Freight Label Detail",
        endpoint: {
          primary: "AlmondcoFreightLabelDetail",
          filter: `LotNo eq ${this.baseView.query.LotNo} and LotSequenceNo eq ${this.baseView.query.LotSequenceNo}`,
        },
        gridData: {
          gridOptions: {
            // Data source key is required
            // However, it is not used when dataGridViews are defined.
            dataSource: {
              allowGrouping: false,
              serverPaging: true,
            },
            dataGridViews: [
              {
                label: "Details",
                value: "details",
                default: true,
                dataSource: {
                  endpoint: "AlmondcoFreightLabelDetail",
                  filter: [
                    ["LotNo", "=", parseInt(this.baseView.query.LotNo)],
                    "and",
                    [
                      "LotSequenceNo",
                      "=",
                      parseInt(this.baseView.query.LotSequenceNo),
                    ],
                  ],
                  serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback: this.BinsPostProcess,
                },
                columns: this.getColumns,
              },
              {
                label: "Select bins",
                value: "bins",
                default: false,
                dataSource: {
                  endpoint: "AlmondcoFreightLabelDetail",
                  filter: ["ProductCode", "=", this.baseView.query.ProductCode],
                  serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback: this.BinsPostProcess,
                },
                columns: this.getColumns,
              },
            ],
          },
          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: true,
            review: true,
            audit: false,
          },
          columns: this.getReviewColumns,
        },
        footerData: {
          footerItems: [],
        },
      };
    },
    getColumns() {
      return [
        {
          // visible: true,
          screenField: "CheckInclude",
          label: "",
          allowEditing: false,
          defaultValue: false,
          valueChangeCallBack: this.checkBoxValueChange,
          allowHiding: false,
          // showInColumnChooser: true,
          showInColumnChooser: this.dataViewType == "bins",
          visible: this.dataViewType == "bins",
        },
        {
          screenField: "SeasonYear",
          dataField: "SeasonYear",
          type: "Integer",
        },
        {
          screenField: "Docket",
          dataField: "DepotDocket",
          type: "Integer",
        },
        {
          screenField: "RunNo",
        },
        {
          screenField: "BinCardNo",
          dataField: "BinCardNo",
          type: "Integer",
        },
        {
          screenField: "Bags",
          dataField: "BagsPerPallet",
          type: "Integer",
        },
        {
          screenField: "AlmondcoProduct",
          filterIndex: 2,
          filterDataField: "ProductDescription",
        },
        {
          screenField: "Branch",
          filterIndex: 0,
          filterDataField: "BranchCode",
        },
        {
          screenField: "LotNo",
          sortOrder: "desc",
          sortIndex: 1,
          dataSourceConfig: {
            endpoint: "api/AlmondcoInshellLotNo",
            sort: {
              selector: "LotNo",
              desc: true,
            },
            filter: "",
          },
          editorTemplate: {
            primary: [
              {
                dataField: "LotNo",
              },
            ],
          },
          filterIndex: 1,
          filterDataField: "LotNo",
          valueExpr: "LotNo",
          displayExpr: "LotNo",
          showInColumnChooser: this.dataViewType == "bins",
          visible: this.dataViewType == "bins",
        },
        {
          screenField: "SequenceNo",
          dataField: "LotSequenceNo",
          sortOrder: "asc",
          sortIndex: 2,
          showInColumnChooser: this.dataViewType == "bins",
          visible: this.dataViewType == "bins",
        },
      ];
    },
  },
  async created() {
    this.initialized();
  },
  methods: {
    // Find bins that match the lot and sequence number and make them checked by default
    BinsPostProcess(data) {
      data.forEach((item) => {
        if (
          item.LotNo == this.baseView.query.LotNo &&
          item.LotSequenceNo == this.baseView.query.LotSequenceNo
        ) {
          this.selectedRows[item.RecordId._value] = undefined;
          this.originalBins[item.RecordId._value] = undefined;
          item["CheckInclude"] = true;
        }
      });
      return data;
    },
    async saveCallback(headerData) {
      if (headerData.saveOption == "C") {
        this.$router.push({
          path: `/almondco-freight-labels/review/${this.baseView.id}`,
          query: this.baseView.query,
        });
      } else if (headerData.saveOption == "S") {
        this.setLoading = true;

        // Remove bins from intake bin
        for (var recordId in this.originalBins) {
          if (!(recordId in this.selectedRows)) {
            await ApiService.post("api/Save_AlmondcoInshellBinLot", {
              RecordId: recordId,
              LotNo: 0,
              LotSequenceNo: 0,
            })
              .then((res) => {
                if (res.statusText == "Created") {
                  this.$notify("Successfully removed bin from pallet");
                }
              })
              .catch((err) => {
                this.setLoading = false;
                this.serverError = {
                  err: err,
                  msg: "Update failed",
                  time: new Date().getTime(),
                };
              });
          }
        }

        for (recordId in this.selectedRows) {
          await ApiService.post("api/Save_AlmondcoInshellBinLot", {
            RecordId: recordId,
            LotNo: parseInt(headerData.LotNo),
            LotSequenceNo: parseInt(headerData.LotSequenceNo),
          })
            .then((res) => {
              if (res.statusText == "Created") {
                this.$notify("Successfully added bin to pallet");
              }
            })
            .catch((err) => {
              this.setLoading = false;
              this.serverError = {
                err: err,
                msg: "Update failed",
                time: new Date().getTime(),
              };
            });
          // }
        }

        this.setIgnoreRouteChangeConfirmation();
        this.reload = true;

        var targetQuery = this.baseView.query;
        targetQuery.LotNo = headerData.LotNo;
        targetQuery.LotSequenceNo = headerData.LotSequenceNo;

        this.$router
          .push({
            path: `/almondco-freight-labels/review/${this.baseView.id}`,
            query: targetQuery,
          })
          .then(() => {
            this.loaded = false;
            this.setLoading = false;
            this.initialized();
          });
      }
    },
    checkBoxValueChange(fieldData, recordData) {
      this.checkBoxValuesHaveChanged = true;
      if (fieldData.value == true) {
        this.selectedRows[recordData.data.RecordId._value] = undefined;
      } else {
        delete this.selectedRows[recordData.data.RecordId._value];
      }
    },
    isCreateMode() {
      return this.baseView.mode == "create";
    },
    isEditMode() {
      return this.baseView.mode == "edit";
    },
    isReviewMode() {
      return this.baseView.mode == "review";
    },
    async initialized() {
      this.selectedRows = {};
      this.originalBins = {};
      this.loaded = true;
      this.reload = false;
    },
  },
};
</script>
